import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "./macrostrategymodal.css";
import TrancheInner from "./TrancheInner";
import TrancheCard from "./TrancheCard";
import { MACROSTRATEGY_TRANCHE_A_ADDRESS } from "../../../utils/constants";
import { zeroAddress } from "viem";
import TrancheComingSoon from "./TrancheComingSoon";

interface MacrostrategyModalProps {
  open: boolean;
  onClose: () => void;
}

const MacrostrategyModal: React.FC<MacrostrategyModalProps> = ({ open, onClose }) => {
  const [activeTranche, setActiveTranche] = useState(0);

  const tranches = [
    {
      id: 1,
      name: "Tranche A",
      address: MACROSTRATEGY_TRANCHE_A_ADDRESS,
      rewards: "S",
      minContribution: 1,
      status: "active"
    },
    {
      id: 2,
      name: "Tranche B",
      address: zeroAddress,
      rewards: "S",
      minContribution: 1,
      status: "coming_soon",
    },
    {
      id: 3,
      name: "Tranche C",
      address: zeroAddress,
      rewards: "S",
      minContribution: 1,
      status: "coming_soon",
    },
  ]

  // MODAL OPEN AND CLOSE
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div data-state="open" className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" style={{ pointerEvents: "auto" }} data-aria-hidden="true" aria-hidden="true">
      <div
        ref={modalRef}
        role="dialog"
        id="radix-:r4f:"
        aria-describedby="radix-:r4h:"
        aria-labelledby="radix-:r4g:"
        data-state="open"
        className="text-sm fixed left-[50%] top-[50%] z-50 grid w-full max-w-modal translate-x-[-50%] translate-y-[-50%] gap-4 border border-slate-200 p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg dark:border-slate-800 dark:bg-slate-950 bg-primary text-white"
        tabIndex={-1}
        style={{ pointerEvents: "auto", border: "none", background: "rgb(16, 44, 57)" }}
      >

        {activeTranche === 0 && (
          <div className="sc-424b74a5-0 gwBYWa">
            <h2 className="sc-424b74a5-1 jACEWN">MacroStrategy Bonds</h2>
            <div className="sc-ad7d017b-0 dVHzZW">
              <p className="sc-ad7d017b-1 NlpUb" style={{textAlign: "left"}}>
                <a
                  target="_blank"
                  href="https://x.com/BigcoinGigaChad"
                  style={{ color: "rgb(29, 161, 242)", display: "inline" }}
                >
                  MICHAEL BAYLOR
                </a>{" "}
                has created{" "}
                <a
                  target="_blank"
                  href="/macrostrategy.pdf"
                  style={{ color: "rgb(249, 194, 44)", display: "inline" }}
                >
                  macrostrategy
                </a>
                . Stake in their bonds to earn yields backed by macrostrategy operations.{" "}
              </p>
            </div>
            <div className="sc-ad7d017b-2 gcTChb">
              {tranches.map((tranche) => (
                tranche.status === "active" ? (
                  <TrancheCard setActiveTranche={setActiveTranche} tranche={tranche} />
                ) : (
                  <TrancheComingSoon
                    tranche={tranche}
                    key={tranche.id}
                  />
                )
              ))}
            </div>
            <div className="sc-43f175b-3 gdtvnF">
              <button className="sc-cdc39d4e-0 gvrgXY" onClick={onClose}>Close</button>
            </div>
          </div>
        )}
        {activeTranche === 1 && (
          <TrancheInner setActiveTranche={setActiveTranche} tranche={tranches[activeTranche-1]} />
        )}
      </div>
    </div>
  );
}
export default MacrostrategyModal;